"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PHONE_REGEX = exports.BLOCK_INVENTORY = exports.PREPAID_DISCOUNT_PERCENT = exports.MAX_PREPAID_DISCOUNT = exports.COD_CHARGES = void 0;
exports.COD_CHARGES = "COD_CHARGES";
exports.MAX_PREPAID_DISCOUNT = "MAX_PREPAID_DISCOUNT";
exports.PREPAID_DISCOUNT_PERCENT = "PREPAID_DISCOUNT_PERCENT";
exports.BLOCK_INVENTORY = "BLOCK_INVENTORY";
exports.PHONE_REGEX = /^\d{10}$/;
